function getCookie(name) {
  return document.cookie
    .split("; ")
    .find(row => row.startsWith(name + "="))
    ?.split("=")[1];
}

async function ensureCsrfCookie() {
  const token = getCookie("XSRF-TOKEN");
  if (token) return token;
  // einmal „anwärmen“, damit das Cookie gesetzt wird
  await fetch("/api/auth/me", { method: "GET", credentials: "include" }).catch(() => {});
  return getCookie("XSRF-TOKEN");
}

export async function fetchJson(url, { method = "GET", headers = {}, body } = {}) {
  const opts = {
    method,
    credentials: "include",
    headers: { ...headers },
  };

  if (body !== undefined && body !== null) {
    opts.headers["Content-Type"] = "application/json";
    opts.body = typeof body === "string" ? body : JSON.stringify(body);
  }

  // PUT/POST/PATCH/DELETE -> CSRF-Header setzen
  if (/^(POST|PUT|PATCH|DELETE)$/i.test(method)) {
    const xsrf = await ensureCsrfCookie();
    if (xsrf) {
      opts.headers["X-XSRF-TOKEN"] = decodeURIComponent(xsrf);
      // Debug:
      // console.log("X-XSRF-TOKEN set:", opts.headers["X-XSRF-TOKEN"].slice(0,8)+"...");
    }
  }

  const res = await fetch(url, opts);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${res.statusText} – ${text || url}`);
  }
  if (res.status === 204) return null;
  const ct = res.headers.get("content-type") || "";
  return ct.includes("application/json") ? res.json() : res.text();
}
